import { useState } from "react";
import { Col, Container, Modal, Row } from "react-bootstrap";
import OdsBaseTable from "../../components/base-table/base-table";
import { ColumnDefinition, CvxButton, CvxSpinnerButton } from "../../modules/cvx-ui-module";

export interface OdsMultiEditColumnDialogProps {
    show: boolean;
    header: string;
    editControl: JSX.Element,
    data: any[];
    columns: ColumnDefinition<any>[];
    onComplete: (dialogResult: boolean) => Promise<void>;
}

const OdsMultiEditColumnDialog: React.FC<OdsMultiEditColumnDialogProps> = ({
    show,
    header,
    editControl,
    data,
    columns,
    onComplete,
    ...props
}) => {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    const onSubmit = async (): Promise<any> => {
        setIsSaving(true);
        await onComplete(true);
        setIsSaving(false);
    };

    const onCancel = () => {
        if (onComplete) {
            onComplete(false);
        }
    };

    return (
        <Modal className="theme-blue" size="xl" show={show} centered backdrop="static" onHide={onCancel}>
            <Modal.Header>
                <Modal.Title>Edit {header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>{editControl}</Row>
                    <Row>
                        <Col style={{ marginTop: '20px' }}>
                            <OdsBaseTable heading={`Edit ${header}`} columns={columns} dataSource={data} isLoading={false} overridePageSize={10} />
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <CvxButton theme='accent' onClick={onCancel}>Cancel</CvxButton>
                <CvxSpinnerButton theme='primary' showSpinner={isSaving} onClick={onSubmit}>Save All</CvxSpinnerButton>
            </Modal.Footer>
        </Modal>
    );
};

export default OdsMultiEditColumnDialog;
